export default {
	active: "Active",
	content: "Content",
	controls: {
		clearDisplay: "Clear Display",
		playVideo: "Play Video",
		sendMessage: "Send Message",
		title: "Display Control",
	},
	deviceAuth: {
		authorize: "Authorize Device",
		enterCode: "Enter the code displayed on the TV",
		error: "Error authorizing device",
		selectTemple: "Select Temple",
		subtitle: "Connect a TV or device to the temple",
		success: "Device authorized successfully!",
		successDesc: "The TV can now display your temple's tickets.",
		title: "Authorize Device",
	},
	editMessage: "Edit Message",
	inactive: "Inactive",
	messageTitle: "Title",
	messages: {
		cleared: "Display cleared",
		confirmDelete: "Are you sure you want to delete this message?",
		created: "Message created successfully",
		deleted: "Message deleted successfully",
		sent: "Message sent to display",
		updated: "Message updated successfully",
		videoSent: "Video sent to display",
	},
	newMessage: "New Message",
	oriTv: {
		compatibility: "Compatible with Fire TV Stick, Android TV and Android tablets",
		description:
			"Install the ORI TV app on your Fire TV Stick or Android TV to display ticket calls, messages and videos on the temple screen.",
		download: "Download ORI TV (.apk)",
		step1: "Download and install the APK on the device (Fire TV Stick, Android TV or tablet)",
		step2: "Open the app and go to the address shown on screen to authorize",
		step3: "Done! Tickets and messages will automatically appear on the TV",
		title: "ORI TV App",
		version: "Version",
	},
	showInQueue: "Show in queue (TV footer)",
	sortOrder: "Order",
	subtitle: "Manage messages and videos displayed on the temple TV",
	title: "Display / TV",
	totalMessages: "Total",
	type: "Type",
	types: {
		TEXT: "Text",
		VIDEO: "Video",
	},
	videoUrl: "Video URL (YouTube)",
};
